import {Instance, types} from 'mobx-state-tree';
import {EntityBaseInfo} from 'core/models';

const BlendInfo = types.compose(EntityBaseInfo, types.model('BlendInfo', {}));

export type TBlendInfoModel = Instance<typeof BlendInfo>;

export {BlendInfo};
